export const STATUS_BAR_BRAND_COLOR = "#ed354f";
export const SYSTEM_NAV_COLOR = "#ffffff";
export const DEFAULT_STATUS_BAR_COLOR = STATUS_BAR_BRAND_COLOR;
export const BODY_BG_COLOR = "#f3f4f6";

export const STATUS_BAR_COLORS = {
  brand: STATUS_BAR_BRAND_COLOR,
  default: STATUS_BAR_BRAND_COLOR,
  home: STATUS_BAR_BRAND_COLOR,
  header: STATUS_BAR_BRAND_COLOR,
  sheet: STATUS_BAR_BRAND_COLOR,
  overlay: STATUS_BAR_BRAND_COLOR,
};
